"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eachComponentDataAsync = void 0;
const lodash_1 = require("lodash");
const index_1 = require("./index");
const eachComponentAsync_1 = require("./eachComponentAsync");
// Async each component data.
const eachComponentDataAsync = (components_1, data_1, fn_1, ...args_1) => __awaiter(void 0, [components_1, data_1, fn_1, ...args_1], void 0, function* (components, data, fn, path = '', index, parent, includeAll = false) {
    if (!components) {
        return;
    }
    return yield (0, eachComponentAsync_1.eachComponentAsync)(components, (component, compPath, componentComponents, compParent) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const row = (0, index_1.getContextualRowData)(component, compPath, data);
        if ((yield fn(component, data, row, compPath, componentComponents, index, compParent)) === true) {
            return true;
        }
        if ((0, index_1.isComponentNestedDataType)(component)) {
            const value = (0, lodash_1.get)(data, compPath, data);
            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const nestedComponentPath = (0, index_1.getModelType)(component) === 'nestedDataArray'
                        ? `${compPath}[${i}].data`
                        : `${compPath}[${i}]`;
                    yield (0, exports.eachComponentDataAsync)(component.components, data, fn, nestedComponentPath, i, component, includeAll);
                }
                return true;
            }
            else if ((0, lodash_1.isEmpty)(row) && !includeAll) {
                // Tree components may submit empty objects; since we've already evaluated the parent tree/layout component, we won't worry about constituent elements
                return true;
            }
            if ((0, index_1.getModelType)(component) === 'dataObject') {
                const nestedFormValue = (0, lodash_1.get)(data, component.path);
                const noReferenceAttached = (nestedFormValue === null || nestedFormValue === void 0 ? void 0 : nestedFormValue._id)
                    ? (0, lodash_1.isEmpty)(nestedFormValue.data) && !(0, lodash_1.has)(nestedFormValue, 'form')
                    : false;
                const shouldBeCleared = (!component.hasOwnProperty('clearOnHide') || component.clearOnHide) &&
                    (component.hidden || ((_a = component.ephermalState) === null || _a === void 0 ? void 0 : _a.conditionallyHidden));
                // Skip all the nested components processing if nested form is hidden and should be cleared on hide or if submission is saved as reference and not loaded
                const shouldSkipProcessingNestedFormData = noReferenceAttached || shouldBeCleared;
                if (!shouldSkipProcessingNestedFormData) {
                    // For nested forms, we need to reset the "data" and "path" objects for all of the children components, and then re-establish the data when it is done.
                    const childPath = (0, index_1.componentDataPath)(component, path, compPath);
                    const childData = (0, lodash_1.get)(data, childPath, null);
                    yield (0, exports.eachComponentDataAsync)(component.components, childData, fn, '', index, component, includeAll);
                    (0, lodash_1.set)(data, childPath, childData);
                }
            }
            else {
                yield (0, exports.eachComponentDataAsync)(component.components, data, fn, (0, index_1.componentDataPath)(component, path, compPath), index, component, includeAll);
            }
            return true;
        }
        else if ((0, index_1.getModelType)(component) === 'none') {
            const info = (0, index_1.componentInfo)(component);
            if (info.hasColumns) {
                const columnsComponent = component;
                for (const column of columnsComponent.columns) {
                    yield (0, exports.eachComponentDataAsync)(column.components, data, fn, path, index, component);
                }
            }
            else if (info.hasRows) {
                const rowsComponent = component;
                for (const rowArray of rowsComponent.rows) {
                    if (Array.isArray(rowArray)) {
                        for (const row of rowArray) {
                            yield (0, exports.eachComponentDataAsync)(row.components, data, fn, path, index, component);
                        }
                    }
                }
            }
            else if (info.hasComps) {
                const componentWithChildren = component;
                yield (0, exports.eachComponentDataAsync)(componentWithChildren.components, data, fn, (0, index_1.componentFormPath)(componentWithChildren, path, componentWithChildren.path), index, component);
            }
            return true;
        }
        return false;
    }), true, path, parent);
});
exports.eachComponentDataAsync = eachComponentDataAsync;
